import { axiosConfig } from './axios-config.js'

export const homeCareReport = {
  getReport: (token, date) => {
    const params = {}
    if (date) params.date = date
    return axiosConfig.get('/api/home-care-report/' + token, { params })
  }
}
